export const getZunoScript = (section: string) => {
  const domainUrl = window.location.host.split(".");
  const zunoKey = domainUrl[0] === "www" ? "zuno-foundit" : "zuno";
  const script = `https://media.foundit.in/${zunoKey}/assets/build/pages/${section}/js/index.js`;
  return script;
};
